export const SERVER_URL = "http://35.169.152.152";
// export const SERVER_URL = "https://demo.imatsbi2.com";

export const WEB_SOCKET_URL = "ws://localhost:6191";
export const IRIS_BRIDGE_VERSION = "26.3.1";

const ipv4Regex =
  /^(https?:\/\/)?((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

let origin = window.location.origin;

const isLocalHost = origin.includes("localhost");

let PORT = "";

if (ipv4Regex.test(origin)) {
  origin = origin;
  PORT = ":8080";
}

export const BASE_URL = `${origin + "" + PORT + "/api/"}`;
export const UPLOAD_URL = !isLocalHost
  ? `${origin}/api/`
  : `${SERVER_URL + ":8080"}/api/`;
export const PHOTOS_BASE_URL = !isLocalHost
  ? `${origin}/photos/`
  : `${SERVER_URL}/photos/`;
export const PHOTOS_BASE_URL_LOGO = !isLocalHost
  ? `${origin}/photos/logos/`
  : `${SERVER_URL}/photos/logos/`;
export const DOCUMENTS_BASE_URL = !isLocalHost
  ? `${origin}/documents/`
  : `${SERVER_URL}/documents/`;

const API_ENDPOINTS = {
  before_login: {
    login: `login`,
    verify: `verify`,
  },
  updatePassword: "update_password",
  profile: "profile",
  folderSearch: `bookings/jackets/search`,
  bookingsSearch: `bookings/search`,
  civilPaperSearch: `civilPaper/search`,
  getCivilPaperByID: `civilPaper/`,
  civilPaperSave: `civilPaper/save`,
  civilPaperBusinessSearch: `civilPaper/business/search`,
  // Delete endpoints — confirmed real routes (Swagger). Queued locally on
  // delete (matching Bookings' setDeleteAPis pattern) and fired on Save
  // Changes, same as Civil Papers has no redux slice of its own to collect
  // them in.
  civilPaperDelete: `civilPaper/id/`,
  civilPaperDeletePeople: `civilPaper/people/id/`,
  civilPaperDeleteLinkedDocuments: `civilPaper/linkedDocuments/id/`,
  civilPaperDeleteServiceTypes: `civilPaper/serviceTypes/id/`,
  civilPaperDeleteServiceDocuments: `civilPaper/serviceDocuments/id/`,
  civilPaperDeleteServiceAttempt: `civilPaper/serviceAttempt/id/`,
  civilPaperDeleteCashAccountingNew: `civilPaper/cashAccountingNew/id/`,
  civilPaperDeleteTrustAccountingNew: `civilPaper/trustAccountingNew/id/`,
  civilPaperDeleteCashAccountingNewTransactions: `civilPaper/cashAccountingNewTransactions/id/`,
  civilPaperDeleteTrustAccountingNewTransactions: `civilPaper/trustAccountingNewTransactions/id/`,
  // NOT confirmed against Swagger yet — assumed from the naming of the
  // routes above (Monroe's Problem Files list, CivilPaperProblemFiles.jsx).
  civilPaperDeleteProblemFiles: `civilPaper/problemFiles/id/`,
  // Dynamic "Extra" table field defs — same generic mechanism as
  // getBioExtra/getWarrantExtra (see getExtraTableData/saveExtraTable
  // below for the matching GET-data/POST-save endpoints).
  getCivilPapersNewExtraFields: "bookings/get/extra/table/details/CivilPapersNewExtra",
  getTrustAccountingNewExtraFields: "bookings/get/extra/table/details/TrustAccountingNewExtra",
  getCivilPapersPeopleExtraFields: "bookings/get/extra/table/details/CivilPapersPeopleExtra",
  getAttorneyExtraFields: "bookings/get/extra/table/details/AttorneyExtra",
  getBusinessesExtraFields: "bookings/get/extra/table/details/BusinessesExtra",
  bookingsFullSearch: `bookings/full/search`,
  bookingQueue: `bookingsQueue/search`,
  clientParams: `clientParams/all`,
  // Per-user grid column layout ("Config" button) — legacy ClientParams2
  // table, distinct from the group-scoped `clientParams`/`config.clientParams`
  // above. See docs/plans/grid-column-config-feature.md §6.
  clientParams2: {
    getByContextName: "clientparams2/getBy/contextName/",
    save: "clientparams2/save",
  },
  refList: `ref-list/getRefList`,
  refListItemContexts: `config/getAll/refListItemContexts`,
  associates: `bookings/jacketsJackets/`,
  bookings: `bookings`,
  bookingsCreate: `bookings/create`,
  bookingsByBookingId: `bookings/bookingId/`,
  countyLogo: `clientParams/Globals/ClientLogo`,
  bookingIntakeCreate: "bookings_intake/create",
  staffIdByUser: "get/staff/details/username/",
  imageUpload: "bookings/bio/bioPhotos/photos",
  documentUpload: "bookings/bio/documents",
  latestBooking: "get/latest/bookings/details",
  latestStaffBooking: "get/latest/staff/bookings/details", // staff
  getBookingByID: "bookings/bookingNumber/id/",
  getBioExtra: "bookings/get/extra/table/details/BioExtra",
  getBookingExtra: "bookings/get/extra/table/details/ArrestReportsExtra",
  getTableColumns: "bookings/get/extra/table/details",
  // Generic "extra" table GET/save — same endpoints Warrants uses for
  // WarrantsExtra (see API_ENDPOINTS.warrants below): GET returns the saved
  // row(s) for {tableName}/{idColumn}/{id}; POST creates/updates a row.
  getExtraTableData: "extra/",
  saveExtraTable: "extra/save",
  charges: "bookings/charges",
  signature: "signature/bookingSignature",
  releaseInformation: "bookings/releaseNotes",
  movementRule: "bookings/inmateMovementRule",
  hold: "bookings/holds",
  billing: "inmate/billing",
  medication: "bookings/medications",
  appoinmentLog: "bookings/appointmentLog",
  victimLog: "bookings/victimNotification",
  distinguishingCharacteristics: "bookings/distinguishingCharacteristics",
  miscellaneousNumber: "bookings/miscellaneousNumber",
  bioPhotos: "bookings/bioPhotos",
  addresses: "bookings/addresses",
  bookingBailPayments: "bookings/delete/bookingBailPayment",
  bookingBails: "bookings/delete/bookingBails",
  releaseQueueList: "releaseQueueDetails/search",
  jacketFlags: "bookings_intake/cdInvolvements/id/",
  bookingQueueDetails: "bookingsQueue/details/id/",
  releaseQueueDetails: "releaseQueueDetails/id/",
  linkedScannedDocuments: "bookings_intake/bookingLinkedDocuments",
  bioAliases: "bookings/bioAliases",
  vwCharges_refListItemGlobalID: "get/vwCharges/refListItemGlobalID",
  inmateProperty: "inmate/inmateProperty/id/",
  scheduledEvents: "bookings/scheduledEvents/id/",
  Charge_create: "bookings/create/charges",
  Charge_update: "bookings/update/charges",
  bookingBailPayment_create: "bookings/create/bookingBailPayment",
  bookingBailPayment_update: "bookings/update/bookingBailPayment",
  reset_mfa: "reset_mfa",
  medicalAuthorizationsSpecific: "bookings/medicalAuthorizationsSpecific/id/",
  HousingSuggestion: "housingCurrentStatus/getHousingSuggestion",
  medicalQuestionnaires: "bookings_intake/medicalQuestionnaires/id/",
  inmateClassificationQuestionnaires:
    "inmate/inmateClassificationQuestionnaires/id/",
  medicalAuthorizationIsolation: "booking/medicalAuthorizationIsolation/id/",
  inmateBillingReport: "bookings/inmateBillingReport",
  getAllConfig: "getAll/config",
  updateConfig: "update/config",
  cellBlockSuggestion: "housingCurrentStatus/getCellOrBedSuggestion",
  cellBedList: "bookings_intake",
  destinationList: "bookings_intake/destinationList",
  deleteBioAddresses: "bookings/bioAddressesId",
  auditLogSearch: "auditLog/search",
  auditLogSave: "audit/save",
  inmateBatchMovementList: "inmateBatchMovement/list",
  inmateBatchMovementCreate: "inmateBatchMovement/create",
  irisSearch: "bookings/iris/search",
  irisListSearch: "bookings/iris/listSearch",
  irish: "irish/",
  judgeList: "bookings/judgeNameList",
  getLatestBookingsByjacketID: "bookings/get/latest/jacket/bookingsDetails/",
  inmateSearchByBookingNumber: "bookings/singleSearch/bookingNumber/",
  getFlagByJacketID: "flags/jacket/",
  getFlagByBookingID: "flags/booking/",
  // Full jacket replace (jacketId, bio, cdInvolvements, officerReports, ...
  // the whole record) — confirmed real endpoint/request shape. Used by
  // Civil Papers to persist the "Civil" (FLAGTYPES_DOCUMENTS) jacket flag
  // add/remove — see util/civilPaperJacketFlagActions.js. Fetch the current
  // jacket first (API_ENDPOINTS.warrants.jacketDetailByID) and only change
  // cdInvolvements before posting here, since this looks like a full
  // replace, not a partial-field merge. The cdInvolvements sent must be the
  // jacket's full flag set: build it from getFlagByJacketID (the saved
  // flags) merged over the jacket's own rows.
  jacketEdit: "bookings/bio/jackets/edit",
  dashboard: "dashboard",
  config: {
    tableName: "config/getAll/tableName",
    configDefaults: {
      getAll: "config/defaults/getAll",
    },
    configModule: {
      getAllConfig: "config/getAll/config",
      updateConfig: "config/update/config",
      getConfigModuleNew: "config/get/configModuleNew/id/",
      getAllConfigModule: "config/getAll/configModule",
      updateConfigModule: "config/update/configModule",

      // Submodules
      getAllConfigSubModules: "config/getAll/configSubmodules",
      getConfigSubModules: "config/get/configSubModule/moduleId",
      getConfigSubModuleById: "config/get/configSubModule/id/",
      createOrUpdateSubModules: "config/createOrUpdate/configSubModule",
      deleteConfigSubModules: "config/configSubModule/id/",

      // Contexts
      getConfigModuleContexts: "config/get/configModuleContext/moduleId/",
      getConfigContextById: "config/get/configModuleContext/id/",
      createOrUpdateConfigContext: "config/createOrUpdate/configModuleContext",
      deleteConfigContext: "config/configModuleContext/id/",

      // Context Params
      getConfigContextParams: "config/get/configModuleContextParams/id/",
      deleteConfigContextParams: "config/configModuleContextParams/id/",

      // ConfigModuleParams
      getConfigModuleParams: "config/get/configModuleParams/moduleId/",
      getConfigParamById: "config/get/configModuleParams/id/",
      createOrUpdateConfigParam: "config/createOrUpdate/configModuleParam",
      deleteConfigParam: "config/configModuleParams/paramId/",
    },
    linkedObject: {
      linkedObjectsList: "config/linkedObjSources/getAll",
      linkedObjectsDelete: "config/delete/linkedObjSource/id/",
      linkedObjectsByID: "config/get/linkedObjSources/id/",
      linkedObjectsCreate: "/config/create/linkedObjSources",
    },
    questionnaire: {
      // Questionnaire
      questionnairesCreate: "config/create/questionnaires",
      questionnairesUpdate: "config/update/questionnaires",
      questionnairesList: "config/getAll/questionnaires",
      questionnairesByID: "config/get/questionnaires/id/",
      questionnairesByBookingID:
        "inmate/inmateClassificationQuestionnaires/bookingId/{bookingId}",
      questionnairesDelete: "config/delete/questionnaires/id/",

      // Question Group
      questionGroupCreate: "config/create/questionGroups",
      questionGroupUpdate: "config/update/questionGroups",
      questionGroupList: "config/getAll/questionGroups",
      questionGroupByID: "config/get/questionGroups/id/",
      questionGroupDelete: "config/delete/questionGroups/id/",

      // Questions
      questionsCreate: "config/create/questions",
      questionsUpdate: "config/update/questions",
      questionsList: "config/getAll/questions",
      questionByID: "config/get/questions/id/",
      questionsDelete: "config/delete/questions/id/",

      // Question Side Effects
      questionSideEffectCreate: "config/create/questionSideEffects",
      questionSideEffectUpdate: "config/update/questionSideEffects",
      questionSideEffectsList: "config/getAll/questionSideEffects",
      questionSideEffectsByID: "config/get/questionSideEffects/id/",
      questionSideEffectsDelete: "config/delete/questionSideEffects/id/",

      // Question Autoset
      questionAutoSetCreate: "config/create/questionAutoSet",
      questionAutoSetUpdate: "config/update/questionAutoSet",
      questionAutoSetList: "config/getAll/questionAutoSet",
      questionAutoSetByID: "config/get/questionAutoSet/id/",
      questionAutoSetDelete: "config/delete/questionAutoSet/id/",

      // Question Attrib
      questionAttribsCreate: "config/create/questionAttribs",
      questionAttribsUpdate: "config/update/questionAttribs",
      questionAttribsList: "config/getAll/questionAttribs",
      questionAttribsByID: "config/get/questionAttribs/id/",
      questionAttribsDelete: "config/delete/questionAttribs/id/",
    },
    clientParams: {
      createOrUpdate: "config/clientParams/createOrUpdate",
      getWithoutStaff: "config/clientParams/get/withoutStaff",
      getAll: "config/clientParams/all",
      getClientLogo: "config/clientParams/Globals/ClientLogo",
      deleteClientParams: "config/clientParams/id/",
    },
    // Site-specific label renames (legacy Vocab table): [{ id, english, other }]
    vocabulary: {
      getAll: "config/getAll/vocabulary",
    },
    tableViewsNew: {
      getAll: "config/getAll/tableViewsNew",
      get: "config/get/tableViewsNew/id/",
      save: "config/save",
      delete: "config/delete/id/",
    },
    feeDescriptions: {
      getAll: "config/getAll/feeDescriptions",
      get: "config/get/feeDescriptions/id/",
    },
    reports: {
      getAll: "config/getAll/reports",
      getById: "config/get/reports/id/",
      deleteReports: "config/delete/reports/id/",
      create: "config/create/reports",
      update: "config/update/reports",
    },
    scheduledEvent: {
      getAll: "config/getAll/scheduledEvent",
      getById: "config/get/scheduledEvent/id/",
      deleteScheduledEvent: "config/delete/scheduledEvent/id/",
      create: "config/create/scheduledEvent",
      update: "config/update/scheduledEvent",
    },
    storedProcedures: {
      getAll: "config/getAll/databaseStatisticProcedures",
      getById: "config/get/databaseStatisticProcedures/id/",
      deleteStoredProcedure: "config/delete/databaseStatisticProcedures/id/",
      createOrUpdate: "config/saveOrUpdate/databaseStatisticProcedure",
    },
    stickyFields: {
      getAll: "config/getAll/configStickyFields",
      getById: "config/get/configStickyFields/id/",
      deleteStickyFields: "config/delete/configStickyFields/id/",
      createOrUpdate: "config/createOrUpdate/configStickyFields",
    },
    mileageRate: {
      getAll: "config/getAll/milageRate",
      getById: "config/get/milageRate/id/",
      deleteMileageRate: "config/delete/milageRate/id/",
      createOrUpdate: "config/saveOrUpdate/mileageRate",
    },
    trainingCourses: {
      getAll: "config/getAll/trainingCourse",
      getById: "config/get/trainingCourse/id/",
      deleteTrainingCourse: "config/delete/trainingCourse/id/",
      createOrUpdate: "config/saveOrUpdate/trainingCourse",
    },
    refList: {
      // Ref List
      getAllRefList: "config/ref-list/getRefLisWithoutItems",
      getRefListByID: "config/ref-list/id/",
      createorUpdateRefList: "config/ref-list/createOrUpdate/refList",
      deleteRefList: "config/ref-list/delete/id/",
      // Ref list item
      getRefListItem: "config/ref-list/items/id/",
      getRefListItemByGlobalId: "config/ref-list/item/globalId/",
      createorUpdateRefListItem: "config/ref-list/createOrUpdate/refListItem",
      deleteRefListItem: "config/ref-list/delete/refListItemId/",
      getRefListItemByID: "ref-list/items/refListItemId/",
      getRefListItemAttribByGlobalID: "config/refListItemAttribs/globalId/",

      // Ref list item context
      getRefListItemContext: "config/get/refListContext/refListItemGlobalID/",
      updateRefListItemContexts: "config/refListItemContexts/",
      getAllRefListItemContexts: "config/getAll/refListItemContexts",

      // Ref list attrib
      getRefListItemWithAttribs: "config/ref-list/refListItemWithAttribs/404",
      getAllRefListItemAttrib: "config/refListItemAttribs/getAll",
      getRefListItemAttribByID: "config/get/refListItemAttribs/id/",
      createOrUpdateReflistItemAttrib: "config/refListItemAttribs",
      deleteRefListItemAttribByID: "config/refListItemAttribID/",

      getManualAndBookingSteps:
        "config/refListItemContexts/getManualAndBookingSteps",
      getAllContextByGlobalId: "config/get/refListContext/refListItemGlobalID/",
      getRefListIdByName: "config/ref-list/name-containing/",
    },
    exportTarget: {
      getAll: "config/getAll/exportTargets",
      getById: "config/get/exportTargets/id/",
      createExportTarget: "config/create/exportTargets",
      updateExportTarget: "config/update/exportTargets",
      deleteExportTarget: "config/delete/exportTargets/id/",
      addSecurity: "security/create/export-target-modules",
      getSecurity: "security/get/export-target-module/exportTargetId/",
      deleteSecurity: "security/delete/export-target-module/",
    },
    holidays: {
      getAll: "config/getAll/holidays",
      getById: "config/get/holidays/id/",
      deleteHolidays: "config/delete/holidays/id/",
      createOrUpdate: "config/saveOrUpdate/holiday",
    },
    actionPaneDivs: {
      getAll: "config/getAll/configActionPaneDivs",
      getById: "config/get/configActionPaneDivs/id/",
      deleteActionPaneDivs: "config/delete/configActionPaneDivs/id/",
      create: "config/create/configActionPaneDivs",
      update: "config/update/configActionPaneDivs",
    },
    actionPaneItems: {
      getAll: "config/getAll/configActionPaneItems",
      getById: "config/get/configActionPaneItems/id/",
      deleteActionPaneItems: "config/delete/configActionPaneItems/id/",
      create: "config/create/configActionPaneItems",
      update: "config/update/configActionPaneItems",
    },
    actionPaneItemHandler: {
      create: "config/create/configActionPaneItemHandler",
      getById: "config/get/configActionPaneItemHandlers/id",
      getByConfigId:
        "config/get/configActionPaneItemHandlers/configActionPaneItemID/",
      delete:
        "config/delete/configActionPaneItemHandlers/ConfigActionPaneItemHandlerId/",
    },
    tableViews: {
      getAll: "config/getAll/tableViewsNew",
    },
  },
  security: {
    staffGroups: {
      getAll: "security/getAll/staff/groups",
      getById: "security/get/staff/groups/id/",
      deleteActionPaneItems: "security/delete/staff/groups/id/",
      create: "security/create/staff/groups",
      update: "security/update/staff/groups",
      getSecurityByStaffID: "security/get/staffGroup/staffId/",
    },
    globalCriteria: {
      update: "security/update/global/criteria",
      create: "security/create/global/criteria",
      getAll: "security/getAll/global/criteria",
      getById: "security/get/global/criteria/id/",
      deleteGlobalCriteria: "security/delete/global/criteria/id/",
    },
    staffGroupMembers: {
      getAll: "security/getAll/staff/group/members",
      getById: "security/get/staff/group/members/id/",
      create: "security/create/staff/group/members",
      update: "security/update/staff/group/members",
      delete: "security/delete/staff/group/members/id/",
      getAllStaffGroup: "security/get/staffGroup/staffId/",
    },
    securityRulesFunctionality: {
      getAll: "security/getAll/security/rules/functionality",
      getById: "security/get/security/rules/functionality/id/",
      create: "security/create/security/rules/functionality",
      update: "security/update/security/rules/functionality",
      delete: "security/delete/security/rules/functionality/id/",
    },
    securityRulesRecords: {
      getAll: "security/getAll/security/rules/records",
      getById: "security/get/security/rules/records/id/",
      create: "security/create/security/rules/records",
      update: "security/update/security/rules/records",
      delete: "security/delete/security/rules/records/id/",
    },
    securityRulesCriteria: {
      getAll: "security/getAll/security/rules/criteria",
      getById: "security/get/security/rules/criteria/id/",
      create: "security/create/security/rules/criteria",
      update: "security/update/security/rules/criteria",
      delete: "security/delete/security/rules/criteria/id/",
    },
  },
  staff: {
    getAll: "staff/getAll",
    staffByID: "staff/get/id/",
    create: "staff/create",
    update: "staff/update",
    delete: "staff/delete/id/",
    searchStaff: "staff/search",
    medicalInfo: {
      delete: "staff/delete/med-history-hr/id/",
    },
    assignment: {
      delete: "staff/delete/staff-service-hr/id/",
    },
    activityLog: {
      delete: "staff/delete/activity-log-hr/id/",
    },
    skill: {
      delete: "staff/delete/skills/id/",
    },
    staffProperty: {
      delete: "staff/delete/staffProperty/id/",
    },
    supplementsList: {
      delete: "staff/delete/staff-supplementals/id/",
    },
    documents: {
      delete: "staff/delete/staff-linked-documents/id/",
    },
    security: {
      groups: {
        get: "security/get/staffGroup/staffId/",
      },
    },
    linkedDocs: {
      delete: "staff/delete/staff-linked-documents/id/",
    },
  },
  users: {
    getAll: "user/getAll",
    staffByID: "user/get/id/",
    create: "user/create",
    update: "user/update",
    delete: "user/delete/id/",
    searchStaff: "user/search",
  },
  facilityLog: {
    search: "/commentLog/search",
    save: "/commentLog/save",
    getByID: "/commentLog/getById/",
    getInmate: "commentLog/bookingSearch",
    getCategoriesById: "commentLog/getCatagories/",
    deleteLinkedDocuments:
      "commentLog/delete/facilityLog/linkedScannedDocuments/",
  },
  inmateWatch: {
    search: "/inmateWatch/search",
  },
  detentions: {
    search: "detentions/search",
    update: "detentions/update",
    getByID: "detentions/id/",
  },
  intakeQueue: {
    getAll: "intakeQueue/search",
    save: "intakeQueue/saveOrUpdate",
    getByID: "intakeQueue/getById/",
    delete: "intakeQueue/delete/",
    intakeQCharges: "bookings_intake/getIntakeQueueCharges",
    fullSearch: "intakeQueue/full/search",
  },
  chargeMaintenance: {
    uploadCSV: "chargeMaintenance/uploadCsv",
    getAll: "chargeMaintenance/search",
    save: "chargeMaintenance/saveChargeMaintenance",
    getByID: "chargeMaintenance/getById/",
  },
  logout: "logout",
  lineups: {
    list: "lineups/search",
    save: "lineups/save",
    getByID: "lineups/",
    listPhotos: "lineups/search/photos",
  },
  visitorLog: {
    search: "visitorLog/search",
    save: "visitorLog/save",
    getByID: "visitorLog/",
    BookingByID: "visitorLog/booking/",
    delete: "visitorLog/",
    deleteLinkedDocs: "visitorLog/visitorLogLinkedDocuments/",
    deleteInmateByID: "visitorLog/visitorLogInmate",
    getVisitorDetailsByID: "visitorLog/VisitosrLogList",
  },
  jailIncidents: {
    search: "jailIncident/search",
    getByID: "jailIncident/",
    save: "jailIncident/save",
    deleteInvolvedOfficers: "jailIncident/jailIncidentsInvolvedOfficer/",
    deleteSupplements: "jailIncident/jailIncidentsSupplemental/",
    deletePhotos: "jailIncident/jailIncidentsPhoto/",
    deleteLinkedDocuments: "jailIncident/jailIncidentsLinkedDocument/",
    deleteReviewHearing:
      "jailIncident/jailIncidentsInvolvedInmateReviewHearing/",
    deleteInvolvedInmate: "jailIncident/jailIncidentsInvolvedInmate/",
  },
  tableView: {
    tableviewQuery: "tableview",
  },
  warrants: {
    searchWarrants: "warrant/search",
    warrantByID: "warrant/",
    save: "warrant/save",
    getWarrantExtra: "bookings/get/extra/table/details/warrantsExtra",
    saveBioAddress: "warrant/address/save",
    jacketDetailByID: "bookings/jackets/id/",
    getExtraFieldsData: "extra/",
    saveWarrantsExtra: "extra/save",
    deleteWarrantRoot: "warrant/",
    deleteWarrant: "warrant/warrant/",
    getWarrantByFolderId: "warrant/jacket/",
  },
  // Data Importer module (spec: docs/plans/data-importer-integration-plan.md).
  // Confirmed with backend 2026-09-10 / 2026-09-11 / 2026-09-15.
  dataImporter: {
    issuedWarrantsSearch: "dataImporter/issuedWarrants/search", // Screen 1 "Defendants"
    dismissedWarrantsSearch: "dataImporter/dismissedWarrants/search", // Screen 2 "Warrants Recalled/Dismissed"
    deleteIssuedWarrant: "dataImporter/issuedWarrants/", // DELETE + id — Screen 1 row delete (spec §2.3)
    // POST + {issuedWarrantId} + "/import" — same payload shape as
    // API_ENDPOINTS.warrants.save (verified field-for-field), called
    // instead of it when the "New Warrant" flow (spec §2.6) originated
    // from Data Importer — see pages/Warrants/index.jsx's saveWarrantAction.
    importIssuedWarrant: "dataImporter/issuedWarrants/",
    // POST + {issuedWarrantId} + "/update" — Screen 1 "Modify" save (defendant
    // + warrant-details fields), confirmed with backend 2026-09-18.
    updateIssuedWarrant: "dataImporter/issuedWarrants/",
    // POST + {dismissedWarrantId} + "/clear" — Screen 2 "Dismiss" action (spec §3.3),
    // built atomically server-side. Confirmed payload shape 2026-09-15:
    // { warrantId, dismissedDate, clearanceComments, clearedByStaffId } — only
    // warrantId (the matched Warrant chosen in the results grid) is sent; the
    // other three are sent null since the backend computes status mapping,
    // clearance fields, cancel-at-state submission, and flag cleanup itself.
    dismissWarrant: "dataImporter/dismissedWarrants/",
    // DELETE + id — Screen 2 row delete (spec §3.1), a real delete unlike
    // Screen 1's virtual-delete sentinel hack. Confirmed via Swagger 2026-09-15.
    deleteDismissedWarrant: "dataImporter/dismissedWarrants/",
  },
  transport: {
    search: "transport/search",
    getByID: "transport/",
    save: "transport/save",
    batchSave: "transport/save/batchTransport",
    fullSearch: "transport/fullSearch",
  },
  workCrew: {
    search: "workCrew/search",
    getByID: "workCrew/",
    save: "workCrew/save",
    fullSearch: "workCrew/fullSearch/native",
    eligibleInmates: "workCrew/eligibleInmates",
    getRosterInmates: "workCrew/rosterInmate/",
    getRosters: "workCrew/roster",
    deleteRoster: "workCrew/roster/",
    deleteRosterInmate: "workCrew/rosterInmate/",
    deleteBlackList: "workCrew/blackList/",
    getInmateTracking: "workCrew/inmateTracking/",
  },
};
export default API_ENDPOINTS;
